import { getUserInfo } from '@/utils/useUserInfo';
import axios from 'axios';

interface RecentlyViewedItemBase {
  itemId: string;
  type: 'product' | 'design';
  name: string;
  image: string | string[];
}

interface ProductExtras {
  price: number;
  comparePrice?: number;
  model3dUrl?: string;
}
interface DesignExtras {
  isPersonalizable: boolean;
}
type RecentlyViewedItem = RecentlyViewedItemBase & Partial<ProductExtras> & Partial<DesignExtras>;;

const trackRecentlyViewedItem = async (item: RecentlyViewedItem) => {
  try {
    const userInfo = await getUserInfo("", true);
    if (!userInfo?.cId) {
      console.warn("No customer ID found. Skipping recently viewed tracking.");
      return;
    }

    const url = `https://nestingale.com/v1/api/customer/recently-viewed?customerId=${userInfo.cId}&itemId=${item.itemId}&type=${item.type}`;

    console.log(`Posting data to ${url} to track customerRecentlyViewed`);

    const payload = {
      customerId: userInfo.cId,
      itemId: item.itemId,
      type: item.type,
      name: item.name,
      image: item.image,
      ...(item.type === 'product' && {
        price: item.price,
        comparePrice: item.comparePrice,
        model3dUrl: item.model3dUrl || null,
      }),
      ...(item.type === 'design' && {
        isPersonalizable: item.isPersonalizable ?? false,
      }),
    };

    await axios.post(url, payload);
    console.log(`Successfully tracked recently viewed ${item.type}:`, item.itemId);
  } catch (error) {
    console.error(`Error tracking recently viewed ${item.type}:`, error);
  }
};
 export default trackRecentlyViewedItem


 //usage
 
//  trackRecentlyViewedItem({
//     itemId: product.id,
//     type: 'product',
//     name: product.name,
//     image: product.imageUrl,
//     price: product.price,
//     comparePrice: product.comparePrice,
//     model3dUrl: product.model3dUrl,
//   });

// trackRecentlyViewedItem({
//     itemId: design.designId,
//     type: 'design',
//     name: design.displayName,
//     image: design.designImages,
//     isPersonalizable:design.isPersonalizable,
//   });
  
  